const footerColumns = [
  {
    title: "榜单入口",
    links: [
      { label: "热度 TOP 榜", href: "#top-ranking" },
      { label: "讨论最多", href: "#most-discussed" },
      { label: "爆款头条", href: "#headlines" },
      { label: "今日更新", href: "#top" },
    ],
  },
  {
    title: "话题分区",
    links: [
      { label: "话题墙", href: "#topic-wall" },
      { label: "考古现场", href: "#topic-wall" },
      { label: "细节党专区", href: "#topic-wall" },
      { label: "瓜点预警", href: "#topic-wall" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "榜单规则说明", href: "#top-ranking" },
      { label: "更新节奏", href: "#headlines" },
      { label: "订阅瓜报", href: "#subscribe" },
      { label: "内容声明", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-3">
              <span className="font-heading text-2xl font-black text-foreground-950">黑料每日</span>
              <span className="font-label text-[10px] uppercase tracking-[0.4em] text-primary-600">
                Daily Gossip
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              黑料每日聚合当天热度最高的爆料，用 TOP 榜与热度排行代替漫无目的的翻找，让点击最高、讨论最多的内容先出现在你眼前。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-primary-950">
                <i className="ri-fire-fill text-base" />
              </span>
              <span className="text-xs text-foreground-600">
                榜单每 10 分钟刷新 · 话题墙每 30 分钟补充
              </span>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h5 className="font-heading text-sm font-semibold text-foreground-950">{col.title}</h5>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料每日 · 站内内容为资讯整理与演示，与任何真实人物无关。</p>
          <div className="flex flex-wrap items-center gap-5">
            <a href="#top" className="transition-colors hover:text-primary-600">
              返回顶部
            </a>
            <a href="#top-ranking" className="transition-colors hover:text-primary-600">
              TOP 榜
            </a>
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line" />
              内容仅供参考
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}